import React, { useEffect, useState } from "react";
import ReactEChartsCore from "echarts-for-react";
import * as echarts from "echarts"; // Import the echarts library
import Card from "react-bootstrap/Card";
import "../../../src/main.css";
import { getColor } from "modules/utilities/utility";

function TicketsOverall({ ticketData, isLoading, error }) {
  const [overAllData, setOverAllData] = useState(ticketData);

  useEffect(() => {
    setOverAllData(ticketData);
  }, [ticketData]);

  let arrayData =
  ticketData && ticketData?.overAllData && Object.entries(ticketData?.overAllData);
  let total = arrayData?.reduce((prev, curr) => {
    return prev + curr[1];
  }, 0);



    const getOption = () => ({
      series: [
        {
          type: "pie",
          radius: ["80%", "90%"],
          center: ["60%", "50%"],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: "center",
          },
          labelLine: {
            show: false,
          },
          data: [
            {
              value:
                overAllData?.overAllData === undefined
                  ? "0"
                  : overAllData?.overAllData?.open,
              name: "Open",
              itemStyle: {
                color: getColor("primary"),
                borderWidth: 2,
                borderColor: "#fff",
                borderType: "solid",
                shadowColor: "#fff",
                shadowBlur: 2,
              },
            },
            {
              value:
                overAllData?.overAllData === undefined
                  ? "0"
                  : overAllData?.overAllData?.pending,
              name: "Pending",
              itemStyle: {
                color: getColor("danger"),
                borderWidth: 2,
                borderColor: "#fff",
                borderType: "solid",
                shadowColor: "#fff",
                shadowBlur: 5,
              },
            },
            {
              value:
                overAllData?.overAllData === undefined
                  ? "0"
                  : overAllData?.overAllData?.resolved,
              name: "resolved",
              itemStyle: {
                color: getColor("info"),
                borderWidth: 2,
                borderType: "solid",
                shadowColor: "#fff",
                borderColor: "#fff",
                shadowBlur: 5,
              },
            },
            {
              value:
                overAllData?.overAllData === undefined
                  ? "0"
                  : overAllData?.overAllData?.closed,
              name: "Closed",
              itemStyle: {
                color: getColor("success"),
                borderWidth: 2,
                borderColor: "#fff",
                borderType: "solid",
                shadowColor: "#fff",
                shadowBlur: 5,
              },
            },
          ],
        },
      ],
      tooltip: {
        trigger: "item",
        padding: [7, 10],
        backgroundColor: getColor("gray-100"),
        borderColor: getColor("gray-300"),
        textStyle: { color: getColor("dark") },
        borderWidth: 1,
        transitionDuration: 0,
        axisPointer: {
          type: "none",
        },
      },
    });

    return (
      <div className="position-relative">
        <Card style={{ width: "23em", height: "10em" }}>
          <Card.Body className="pt-0">
            <div className="d-flex justify-content-between mt-0 p-0">
              <div>
                <div className="font-weight-bold text-black fs-1">Overall</div>
                <ul className="list-unstyled list-style mt-1">
                  <li>
                    <span className="color-bullet bg-primary"></span>
                    <span className="">Open</span>
                  </li>
                  <li>
                    <span className="color-bullet bg-danger"></span>
                    <span className="">Pending</span>
                  </li>
                  <li>
                    <span className="color-bullet bg-info"></span>
                    <span className="">Resolved</span>
                  </li>
                  <li>
                    <span className="color-bullet bg-success"></span>
                    <span className="">Closed</span>
                  </li>
                </ul>
              </div>
              <div
                className="position-absolute"
                style={{ marginLeft: "14.5em", marginTop: "3em" }}
              >
                Total :{total ||"0"}
              </div>
              <ReactEChartsCore
                echarts={echarts}
                option={getOption()}
                style={{ height: "100px", width: "120px" }}
              />
            </div>
          </Card.Body>
        </Card>
      </div>
    );
  }

export default TicketsOverall;
